import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Helpers } from 'src/app/core/helpers';
import { Profile } from 'src/app/core/models/profile';

@Component({
	selector: 'app-how-to',
	templateUrl: './how-to.component.html',
	styleUrl: './how-to.component.less'
})
export class HowToComponent implements OnInit{
	_modalVisible:boolean = false;
	profile = new Profile();
	_osSelected:string = localStorage.getItem('OSSelected')!;
	_valContent:string = '';
	Helper = Helpers
	constructor(
		public _router: Router,
	) {}
	ngOnInit(): void {

	}
	/**
	 * Opens the modal by setting the `_modalVisible` variable to `true`.
	 * This function is used to display a modal in the UI.
	 */
	openModal(): void {
		this._modalVisible = true;
	}

	/**
	 * Closes the modal by setting the `_modalVisible` variable to `false`.
	 * This function is used to hide a modal in the UI.
	 */
	closeModal(): void {
		this._osSelected = localStorage.getItem('OSSelected')!;
		this._modalVisible = false;
	}

	/**
	 * Changes the operating system of the user's device.
	 * @param newOs - The new operating system to set.
	 * Closes the modal after changing the operating system.
	 */
	changeOS(newOs: string): void {
		this._router.navigate(['/how-to/' + newOs]);
		localStorage.setItem('OSSelected', newOs);
		this.closeModal();
	}


	showContent(val:string): void {
		this._valContent = val;
	}
}
